<template>
    <b-container fluid>
        <vue-headful
            title="Nos agences"
        />
        <b-breadcrumb class="mb-0">
            <b-breadcrumb-item href="/">
                <Icon name="home" />
            </b-breadcrumb-item>
            <b-breadcrumb-item>
                Nos agences
            </b-breadcrumb-item>
        </b-breadcrumb>
        <b-row class="justify-content-center">
            <b-col :cols="12" class="col-xxl-10">
                <h1>Nos agences</h1>
                <b-card class="mb-3">
                    <p>Un réseau de magasins et d'ateliers dans toute la France pour vous offrir la meilleure qualité de service. Vous pouvez découvrir les services proposés par nos agences :</p>
                    <b-row>
                        <b-col>
                            <ul>
                                <li>station de freinage et mécanique</li>
                                <li>ABS/EBS</li>
                                <li>station de lavage</li>
                                <li>banc de redressage châssis</li>
                                <li>carrosserie tous métaux</li>
                                <li>cabine de sablage</li>
                            </ul>
                        </b-col>
                        <b-col>
                            <ul>
                                <li>travaux sur citerne</li>
                                <li>cabine de peinture</li>
                                <li>station de jaugeage</li>
                                <li>station de chronotachygraphe</li>
                                <li>et plus de 40 000 pièces référencées !</li>
                            </ul>
                        </b-col>
                    </b-row>
                </b-card>
                <b-alert show variant="warning">
                    <small>Les services proposés par les magasins et les ateliers sont distincts et indépendants du site internet.<br/> Si vous souhaitez profiter d’un service proposé par un magasin ou un atelier, les pièces doivent être commandées via l’agence ou l’atelier en question.</small>
                </b-alert>
                <b-card>
                    <StoresDisplay />
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import vueHeadful from 'vue-headful'
    import StoresDisplay from './StoresDisplay.vue'

    export default {
        name : 'Stores',

        components : {
            vueHeadful,
            StoresDisplay,
        },
    }
</script>
